export function formatSelectOptions(options: { label: string; value: string }[]): string {
  return `[${options.map((option) => `{ "label": ${JSON.stringify(option.label)}, "value": ${JSON.stringify(option.value)} }`).join(', ')}]`
}
